module.exports = __webpack_public_path__ + "img/information_ethical_mob@2x.63f039a.webp";